import { render, staticRenderFns } from "./EvaluationCreate.vue?vue&type=template&id=2795a89c&scoped=true&"
import script from "./EvaluationCreate.vue?vue&type=script&lang=js&"
export * from "./EvaluationCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2795a89c",
  null
  
)

export default component.exports